import {
  Chat as ChatIcon,
  Event as EventIcon,
  Groups as GroupsIcon,
  LibraryBooks as ResourcesIcon,
} from "@mui/icons-material";
import { Grid } from "@mui/material";

// User-facing strings
const STRINGS = {
  CHAT: "Chat",
  EVENT_TIMES: "Event Times",
  MEMBERS: "Members",
  PENDING: "pending",
  RESOURCES: "Resources",
} as const;

import { ActivityCard } from "~ui/atoms/ActivityCard/ActivityCard";

export interface EventActivityCardsProps {
  event: {
    id: string;
    name: string;
    meetingTimes: {
      id: string;
      beginMeetingTime: string;
      endMeetingTime: string;
      capacity: number;
      userHasRsvpd: boolean;
      attendees: {
        id: string;
        firstName: string | null;
        lastName: string | null;
        email: string | null;
        isVetted: boolean;
      }[];
    }[];
    resources: {
      id: string;
      name: string;
      description: string;
      url: string;
    }[];
  };
  memberCount?: number;
  requestCount?: number;
  chatMemberCount?: number;
  onResourcesClick?: () => void;
  onMembersClick?: () => void;
  onChatClick?: () => void;
  onEventTimesClick?: () => void;
}

export const EventActivityCards = ({
  event,
  memberCount,
  requestCount,
  chatMemberCount,
  onResourcesClick,
  onMembersClick,
  onChatClick,
  onEventTimesClick,
}: EventActivityCardsProps) => {
  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard
          title={STRINGS.MEMBERS}
          count={memberCount ?? "—"}
          subtitle={requestCount !== undefined && requestCount > 0 ? `${requestCount} ${STRINGS.PENDING}` : undefined}
          icon={<GroupsIcon />}
          color="primary"
          onClick={onMembersClick}
          data-testid="members-slideout-button"
        />
      </Grid>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard
          title={STRINGS.EVENT_TIMES}
          count={event.meetingTimes.length}
          icon={<EventIcon />}
          color="success"
          onClick={onEventTimesClick}
        />
      </Grid>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard
          title={STRINGS.RESOURCES}
          count={event.resources.length}
          icon={<ResourcesIcon />}
          color="info"
          onClick={onResourcesClick}
        />
      </Grid>
      <Grid
        size={{
          md: 3,
          sm: 6,
          xs: 12,
        }}
      >
        <ActivityCard
          title={STRINGS.CHAT}
          count={chatMemberCount ?? 0}
          icon={<ChatIcon />}
          color="secondary"
          onClick={onChatClick}
        />
      </Grid>
    </Grid>
  );
};
